import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

var CARRIERS = [
  { name: 'iA Financial', file: '1.png' },
  { name: 'Beneva', file: '2.png' },
  { name: 'Manulife', file: '3.png' },
  { name: 'RBC Insurance', file: '4.png' },
  { name: 'BMO Insurance', file: '5.png' },
  { name: 'Assumption Life', file: '6.png' },
  { name: 'Foresters', file: '7.png' },
  { name: 'CPP/Foresters', file: '8.png' },
];

var FAQ_DATA = [
  { q: 'What does disability insurance cover?', a: 'It replaces a portion of your income (typically 60-70%) if you become unable to work due to illness or injury. Benefits are paid monthly, tax-free if you pay your own premiums.' },
  { q: 'How is this different from workers\' compensation?', a: 'Workers\' comp only covers injuries or illnesses that happen at work. Disability insurance covers you regardless of where or how you become disabled — including off-the-job accidents and illnesses.' },
  { q: 'What does "own occupation" mean?', a: 'An "own occupation" policy pays benefits if you can\'t perform your specific job. An "any occupation" policy only pays if you can\'t do any job you\'re qualified for. Own-occ offers stronger protection.' },
  { q: 'How long do benefits last?', a: 'Short-term disability typically covers 3-6 months. Long-term disability can cover you until age 65 or for a specified period. We help you choose the right benefit period.' },
  { q: 'Is there a waiting period before benefits start?', a: 'Yes — most policies have an "elimination period" of 30, 60, or 90 days. A longer wait typically means lower premiums. Choose based on how long your savings can cover expenses.' },
  { q: 'Can I get disability insurance if I\'m self-employed?', a: 'Yes. In fact, it\'s even more important for the self-employed since you don\'t have employer-sponsored group coverage. Individual DI policies are tailored to your income and occupation.' },
];

export default function Home() {
  var history = useHistory();
  var auth = useAuth();
  var isLoggedIn = auth.isLoggedIn;

  var handleQuote = function() {
    if (isLoggedIn) {
      history.push('/quote/DI');
    } else {
      history.push('/login');
    }
  };

  var _m = useState(false);
  var isMobile = _m[0];

  useEffect(function() {
    function check() { _m[1](window.innerWidth < 768); }
    check();
    window.addEventListener('resize', check);
    return function() { window.removeEventListener('resize', check); };
  }, []);

  var _faq = useState(null);
  var openFaq = _faq[0];
  var setOpenFaq = _faq[1];

  return (
    <div style={{ fontFamily: "'Outfit', 'Segoe UI', system-ui, sans-serif", background: '#F0F4F9', minHeight: '100vh' }}>
      {/* Nav */}
      <div style={{ background: '#fff', borderBottom: '1px solid #E2E8F0', padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span onClick={function() { history.push('/'); }} style={{ cursor: 'pointer' }}>
          <img src="./assets/img/logo_new.svg" alt="GetCovered" style={{ height: 32 }} />
        </span>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <span onClick={function() { history.push('/login'); }} style={{ fontSize: 14, color: '#0D1B35', textDecoration: 'none', fontWeight: 600, cursor: 'pointer' }}>Log in</span>
          <span onClick={function() { history.push('/register'); }} style={{ fontSize: 14, background: '#1565C0', color: '#fff', padding: '8px 20px', borderRadius: 10, textDecoration: 'none', fontWeight: 600, cursor: 'pointer' }}>Sign Up</span>
        </div>
      </div>

      {/* Hero */}
      <div style={{ background: 'linear-gradient(135deg, #0D1B35 0%, #1E3A5F 100%)', padding: isMobile ? '48px 20px' : '80px 20px', textAlign: 'center' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div style={{ display: 'inline-block', background: '#266ab333', color: '#93C5FD', fontSize: 12, fontWeight: 600, padding: '6px 14px', borderRadius: 20, marginBottom: 16, letterSpacing: 0.5, textTransform: 'uppercase' }}>
            Insurance Pillar
          </div>
          <h1 style={{ fontFamily: "'DM Serif Display', Georgia, serif", fontSize: isMobile ? 32 : 48, color: '#fff', margin: '0 0 16px', lineHeight: 1.15, fontWeight: 400 }}>
            Disability Insurance That<br />Protects Your Income
          </h1>
          <p style={{ fontSize: isMobile ? 16 : 18, color: '#CBD5E1', lineHeight: 1.6, margin: '0 0 32px', maxWidth: 560, marginLeft: 'auto', marginRight: 'auto' }}>
            Your ability to earn is your most valuable asset. Protect it with income replacement coverage from Canada's top insurers.
          </p>
          <span onClick={handleQuote} style={{ display: 'inline-block', background: '#1565C0', color: '#fff', fontSize: 16, fontWeight: 700, padding: '16px 40px', borderRadius: 13, textDecoration: 'none', boxShadow: '0 4px 20px rgba(21,101,192,0.4)', cursor: 'pointer' }}>
            Get My Disability Quote
          </span>
          <div style={{ fontSize: 13, color: '#94A3B8', marginTop: 12 }}>Free &bull; 2 minutes &bull; No obligation</div>
        </div>
      </div>

      {/* Carrier Trust Bar */}
      <div style={{ background: '#fff', padding: '24px 20px', borderBottom: '1px solid #E2E8F0' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
          <div style={{ fontSize: 12, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16 }}>
            Comparing rates from trusted Canadian carriers
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 20, alignItems: 'center' }}>
            {CARRIERS.map(function(c) {
              return <img key={c.file} src={'./assets/img/companies/' + c.file} alt={c.name} style={{ height: 28, opacity: 0.5, filter: 'grayscale(100%)' }} />;
            })}
          </div>
        </div>
      </div>

      {/* Why DI */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: isMobile ? '48px 20px' : '64px 20px' }}>
        <h2 style={{ fontFamily: "'DM Serif Display', Georgia, serif", fontSize: isMobile ? 26 : 32, color: '#0D1B35', textAlign: 'center', margin: '0 0 40px', fontWeight: 400 }}>
          Why Disability Insurance Matters
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: 20 }}>
          {[
            { title: 'Income Replacement', desc: 'Replace up to 70% of your income if illness or injury prevents you from working.', num: '70%' },
            { title: '1 in 3 Workers', desc: 'Will experience a disability lasting 90+ days before age 65. It\'s more common than you think.', num: '33%' },
            { title: 'Tax-Free Benefits', desc: 'If you pay your own premiums, monthly disability benefits are received completely tax-free.', num: '$0 tax' },
          ].map(function(item) {
            return (
              <div key={item.title} style={{ background: '#fff', borderRadius: 18, padding: 24, border: '1px solid #E2E8F0' }}>
                <div style={{ fontSize: 28, fontWeight: 800, color: '#266ab3', marginBottom: 8, fontFamily: "'DM Serif Display', Georgia, serif" }}>{item.num}</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: '#0D1B35', marginBottom: 6 }}>{item.title}</div>
                <div style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6 }}>{item.desc}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* How It Works */}
      <div style={{ background: '#fff', padding: isMobile ? '48px 20px' : '64px 20px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{ fontFamily: "'DM Serif Display', Georgia, serif", fontSize: isMobile ? 26 : 32, color: '#0D1B35', textAlign: 'center', margin: '0 0 40px', fontWeight: 400 }}>
            How It Works
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: 24 }}>
            {[
              { step: '1', title: 'Tell Us About Your Work', desc: 'Your occupation, income, and coverage needs. Quick and straightforward.' },
              { step: '2', title: 'Compare DI Quotes', desc: 'See premiums from multiple carriers with different benefit periods and waiting periods.' },
              { step: '3', title: 'Secure Your Income', desc: 'Apply online or speak with a licensed advisor to customize your policy.' },
            ].map(function(item) {
              return (
                <div key={item.step} style={{ textAlign: 'center' }}>
                  <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#E6F1FB', color: '#266ab3', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, fontWeight: 800, marginBottom: 12 }}>
                    {item.step}
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: '#0D1B35', marginBottom: 6 }}>{item.title}</div>
                  <div style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6 }}>{item.desc}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* CTA Banner */}
      <div style={{ background: 'linear-gradient(135deg, #266ab3 0%, #1E3A5F 100%)', padding: isMobile ? '40px 20px' : '56px 20px', textAlign: 'center' }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <h2 style={{ fontFamily: "'DM Serif Display', Georgia, serif", fontSize: isMobile ? 24 : 30, color: '#fff', margin: '0 0 12px', fontWeight: 400 }}>
            Your Income Deserves Protection
          </h2>
          <p style={{ fontSize: 15, color: '#CBD5E1', margin: '0 0 24px', lineHeight: 1.5 }}>
            Compare disability insurance rates now — the younger and healthier you are, the lower your premiums.
          </p>
          <span onClick={handleQuote} style={{ display: 'inline-block', background: '#fff', color: '#266ab3', fontSize: 16, fontWeight: 700, padding: '16px 40px', borderRadius: 13, textDecoration: 'none', cursor: 'pointer' }}>
            Get My DI Quote
          </span>
        </div>
      </div>

      {/* FAQ */}
      <div style={{ maxWidth: 700, margin: '0 auto', padding: isMobile ? '48px 20px' : '64px 20px' }}>
        <h2 style={{ fontFamily: "'DM Serif Display', Georgia, serif", fontSize: isMobile ? 26 : 32, color: '#0D1B35', textAlign: 'center', margin: '0 0 32px', fontWeight: 400 }}>
          Frequently Asked Questions
        </h2>
        {FAQ_DATA.map(function(item, i) {
          var isOpen = openFaq === i;
          return (
            <div key={i} style={{ borderBottom: '1px solid #E2E8F0', padding: '16px 0' }}>
              <button
                onClick={function() { setOpenFaq(isOpen ? null : i); }}
                style={{ background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 0 }}
              >
                <span style={{ fontSize: 15, fontWeight: 600, color: '#0D1B35' }}>{item.q}</span>
                <span style={{ fontSize: 20, color: '#6B7280', transform: isOpen ? 'rotate(45deg)' : 'none', transition: 'transform 0.2s' }}>+</span>
              </button>
              {isOpen && (
                <p style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6, margin: '10px 0 0', paddingRight: 32 }}>{item.a}</p>
              )}
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div style={{ background: '#0D1B35', padding: '32px 20px', textAlign: 'center' }}>
        <img src="./assets/img/logo_new.svg" alt="GetCovered" style={{ height: 24, opacity: 0.5, marginBottom: 12 }} />
        <div style={{ fontSize: 12, color: '#64748B' }}>
          &copy; {new Date().getFullYear()} AplusWealth Inc. &bull; All rights reserved.
        </div>
      </div>
    </div>
  );
}
